import React from "react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useNavigate } from "react-router-dom";
import { useContextState } from "../../context/Context";

const Scan = () => {
  const { accountCTX } = useContextState();
  const { setScanResult } = accountCTX
  const navigate = useNavigate();

  const onResult = (result: any) => {
    const qrResult = result[0].rawValue
    // console.log(result.rawValue);
    if (!result) return;
    setScanResult(qrResult)
    // window.sessionStorage.setItem("nj_scan_result", qrResult);
    navigate("/dashboard/result");
  };

  return (
    <div className="w-full h-full flex justify-center items-center bg-transparent">
      <Scanner
        onScan={(result)=>{return onResult(result)}}
        onError={(error: any) => console.log(error?.message)}
      />
    </div>
  );
};

export default Scan;
